import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PaymentThankYou from './pages/PaymentThankYou';
import Payment from './pages/Payment';
import VerifyCertificate from './pages/VerifyCertificate';
import DownloadCertificate from './pages/DownloadCertificate';
import TermsConditions from './pages/TermsConditions';
import PaymentFailed from './pages/PaymentFailed';
import PaymentResult from './pages/PaymentResult';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/payment" element={<Payment />} />
        <Route path="/verify/:id?" element={<VerifyCertificate />} />
        <Route path="/download" element={<DownloadCertificate />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/" element={<VerifyCertificate />} />
        <Route path="/payment-result" element={<PaymentResult />} />
        <Route path="/thank-you" element={<PaymentThankYou />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
      </Routes>
    </Router>
  );
}

export default App;